import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";

import Home from "@/pages/Home";
import Inventory from "@/pages/Inventory";
import VehicleDetails from "@/pages/VehicleDetails";
import Compare from "@/pages/Compare";
import Financing from "@/pages/Financing";
import HowItWorks from "@/pages/HowItWorks";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Legal from "@/pages/Legal";
import Login from "@/pages/Login";
import Dashboard from "@/pages/customer/Dashboard";
import Apply from "@/pages/customer/Apply";
import Admin from "@/pages/admin/Admin";

function AppRouter() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/login" element={<Login />} />
      <Route path="/inventory" element={<Inventory />} />
      <Route path="/vehicle/:id" element={<VehicleDetails />} />
      <Route path="/compare" element={<Compare />} />
      <Route path="/financing" element={<Financing />} />
      <Route path="/how-it-works" element={<HowItWorks />} />
      <Route path="/about" element={<About />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/privacy" element={<Legal page="privacy" />} />
      <Route path="/terms" element={<Legal page="terms" />} />
      <Route path="/financing-disclosure" element={<Legal page="financing-disclosure" />} />
      <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/apply/:id" element={<ProtectedRoute><Apply /></ProtectedRoute>} />
      <Route path="/admin" element={<ProtectedRoute adminOnly><Admin /></ProtectedRoute>} />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRouter />
        <Toaster position="top-right" theme="light" />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
